module.exports = __webpack_public_path__ + "static/media/is-makineleri.73c70513.png";